<template>
    <el-dialog
        class="driver-add-supplier-driver-apply-dialog"
        title="司机申请处理"
        width="780px"
        :visible.sync="visible"
        :before-close="close">
        <div>
            <div class="bold-title">已选中司机：{{ this.checkedData.length }}个</div>
        </div>
        <div>
            <div class="bold-title">司机委派函</div>
            <el-form ref="formRef" :model="formData" :rules="formRules" label-width="130px" label-position="left">
                <el-row v-if="delegateVisible">
                    <el-form-item label="委派函" class="delegate">
                        <el-radio v-model="formData.delegateOnline" :label="DELEGATE_TYPE.ONLINE" @change="radioChange">线上</el-radio>
                        <el-radio v-model="formData.delegateOnline" :label="DELEGATE_TYPE.OFFLINE" @change="radioChange">线下</el-radio>
                    </el-form-item>
                </el-row>
                <!-- 委派函 -->
                <el-row>
                    <div class="delegate-wrapper" v-if="formData.delegateOnline === DELEGATE_TYPE.OFFLINE">
                        <el-form-item label="委派函" prop="delegateFileName" class="delegateFile">
                            <el-input
                                v-model="formData.delegateFileName"
                                placeholder="点击上传附件"
                                readonly
                                style="width: 296px;"
                            />
                            <el-popover placement="right" width="500" trigger="click" @show="showpopover">
                                <div style="text-align: center">
                                    <img :src="imgSrcPath" style="width: 100%">
                                </div>
                                <span slot="reference" v-popover:popover1 class="form-item-btn">示例</span>
                            </el-popover>
                            <span class="form-item-btn" @click="previewFile" v-if="formData.delegateFileUrl">预览</span>
                            <span class="form-item-btn" @click="handleDownloadTemplate('driverDelegateTemplate.docx', '委派函模板', 'docx')">下载模板</span>
                            <register-upload
                                :uploadDisplayType="''"
                                :sizeLimit="6"
                                :typeLimit="{reg: '^\.(jpg|jpeg|png)$', warningText: 'jpg、jpeg、png'}"
                                :accept="'image/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf'"
                                flag="delegateFileName#delegateFileUrl#delegateFileId"
                                :ocr="''"
                                class="upload-item-icon three-btn"
                                @uploadSuccess="handleUploadSuccess"
                            ></register-upload>
                        </el-form-item>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="委派开始时间" prop="delegateStartTime" class="delegateStartTime" style="margin-right: 15px">
                                    <el-date-picker
                                        value-format="yyyy-MM-dd"
                                        v-model="formData.delegateStartTime"
                                        type="date"
                                        placeholder="请选择委派开始时间"
                                        style="width: 100%"
                                        :picker-options="pickerOptionsDelegateStartTime"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="委派结束时间" prop="delegateEndTime" class="delegateEndTime" style="margin-right: 15px">
                                    <el-date-picker
                                    value-format="yyyy-MM-dd"
                                    v-model="formData.delegateEndTime"
                                    type="date"
                                    placeholder="请选择委派结束时间"
                                    style="width: 100%"
                                    :picker-options="pickerOptionsDelegateEndTime"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <!-- 选择签署人，法人，且委派函选择线上时显示出来 -->
                    <div class="delegate-wrapper" v-if="formData.delegateOnline === DELEGATE_TYPE.ONLINE">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="选择签署人" prop="stamperCode" class="stamperCode">
                                    <el-input readonly v-model="formData.stamperName" placeholder="选择签署人">
                                        <template v-slot:append>
                                            <el-button icon="el-icon-s-custom" @click="detaliSearch(stamperParams)"></el-button>
                                        </template>
                                        <template v-slot:suffix>
                                            <i class="el-input__icon el-icon-circle-close" v-if="formData.stamperName" @click="resetAdvanceValue"></i>
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="签署人手机" prop="stamperMobile" style="margin-right: 15px">
                                    <el-input readonly v-model="formData.stamperMobile" placeholder="请输入签署人手机号码" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="委派开始时间" prop="delegateStartTime" class="delegateStartTime" style="margin-right: 15px">
                                    <el-date-picker
                                        value-format="yyyy-MM-dd"
                                        v-model="formData.delegateStartTime"
                                        type="date"
                                        placeholder="请选择委派开始时间"
                                        style="width: 100%"
                                        :picker-options="pickerOptionsDelegateStartTime"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="委派结束时间" prop="delegateEndTime" class="delegateEndTime" style="margin-right: 15px">
                                    <el-date-picker
                                    value-format="yyyy-MM-dd"
                                    v-model="formData.delegateEndTime"
                                    type="date"
                                    placeholder="请选择委派结束时间"
                                    style="width: 100%"
                                    :picker-options="pickerOptionsDelegateEndTime"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="签署方式" prop="pushType" class="push-type-form-item">
                                    <MSelect
                                        :optionNum="'SRM_SUPPLIER_DELEGATE_TYPE'"
                                        :value="formData.pushType"
                                        :filterable="true"
                                        @input="val => handleSelect(val, 'pushType')"
                                    ></MSelect>
                                    <div class="push-type-tip">{{ pushTypeTip[formData.pushType] }}</div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-row>
            </el-form>
            <div v-if="this.checkedData.length === 1">如同意，则系统发起委派函签署流程。</div>
            <div v-if="this.checkedData.length > 1">批量通过，仅支持线上委派函。如同意，则系统发起委派函签署流程。</div>
        </div>
        <preview
            v-if="attachmentShow"
            :attachmentShow.sync="attachmentShow"
            :rowData="rowData"
        ></preview>
        <!-- 高级弹窗组件 -->
        <advance-dialog ref="advanceDialog" @confirm="detaliSearchSure"></advance-dialog>
        <span slot="footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" :loading="loading" @click="submit">同意司机加入</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { passApplyRecord } from '../../../../api/driverAddSupplier.js'
import { getExample, downloadAttachment, checkSupplierIsWhite, checkWPH } from '../../../../api/register/driver.js';
import { REGISTER_SOURCE, PUSH_TYPE } from '../../../../constant/constant.js'
import { DELEGATE_TYPE, stamperParams } from '../keyData/tabs/driver/newUploadVersion/config.js'
import { pickerOptionsDelegateStartDate, pickOptionsDelegateEndDate } from '../keyData/tabs/driver/newUploadVersion/util.js'
import MSelect from '@/components/lots/otpSelect2';
import Preview from '../../../../components/viewAttachment.vue'
import RegisterUpload from '../../../../components/upload/Index.vue';
import AdvanceDialog from '@/components/lots/otpAdvanceDialog';

const INIT_FORM = {
    delegateOnline: DELEGATE_TYPE.ONLINE,
    // delegateOnline: DELEGATE_TYPE.OFFLINE,
    delegateFileId: '', // 委派函文件id
    delegateFileName: '', // 委派函文件名称
    delegateFileUrl: '', // 委派函文件url
    stamperName: '', // 签署人姓名
    stamperCode: '', // 签署人编码
    stamperMobile: '', // 签署人手机号码
    delegateStartTime: '', // 委派函起始日期
    delegateEndTime: '', // 委派函结束日期
    pushType: '', // 签署方式
}

const pushTypeTip = {
    [PUSH_TYPE.ALONE]: '(提交后，即时推送司机委派函给供应商签署，供应商签署完成后，系统自动推送司机签署)',
    [PUSH_TYPE.BATCH]: '(提交后，在委派函管理中发起多个司机委派函的签署，供应商签署完成后，系统再自动推送司机签署)',
}

export default {
    components: { MSelect, Preview, RegisterUpload, AdvanceDialog },
    props: {
        checkedData: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            DELEGATE_TYPE,
            visible: false,
            delegateVisible: false,
            loading: false,
            formData: { ...INIT_FORM },
            formRules: {
                delegateStartTime: [{ required: true, message: '请选择委派开始时间', trigger: ['blur', 'change'] }],
                delegateEndTime: [{ required: true, message: '请选择委派结束时间', trigger: ['blur', 'change'] }],
                // 委派函
                delegateFileName: [{ required: true, message: '请选择委派函', trigger: ['change'] }],
                // 签署人
                stamperCode: [{ required: true, message: '请选择签署人', trigger: ['change'] }],
                // 签署人手机号码
                stamperMobile: [{ required: true, message: '请输入签署人手机号码', trigger: ['change'] }],
                // 签署方式
                pushType: [{ required: true, message: '请选择签署方式', trigger: ['change'] }],
            },
            imgSrcPath: null, // 示例图
            attachmentShow: false,
            rowData: {}, // 预览对象
            pickerOptionsDelegateStartTime: pickerOptionsDelegateStartDate(this),
            pickerOptionsDelegateEndTime: pickOptionsDelegateEndDate(this),
            stamperParams,
            pushTypeTip,
        }
    },
    methods: {
        open() {
            this.visible = true
            if (this.checkedData.length === 1) {
                checkSupplierIsWhite({ supplierCode: this.checkedData[0].supplierCode }).then(res => {
                    if (res && +res.code === 0) {
                        this.delegateVisible = res.data;
                    }
                }).catch(err => {})
            }
        },
        close() {
            this.delegateVisible = false
            this.formData = { ...INIT_FORM }
            this.$nextTick(() => {
                this.$refs.formRef.clearValidate()
                this.visible = false
            })
        },
        radioChange(val) {
            this.formData.delegateStartTime = ''
            this.formData.delegateEndTime = ''
            this.formData.delegateFileId = ''
            this.formData.delegateFileName = ''
            this.formData.delegateFileUrl = ''
            this.formData.stamperName = ''
            this.formData.stamperCode = ''
            this.formData.stamperMobile = ''
            this.formData.pushType = ''
        },
        showpopover() {
            getExample('delegate.jpg').then(res => {
                const blob = new Blob([res], { type: 'text/plain' });
                // this.$set(this.imgSrcPath, URL.createObjectURL(blob));
                this.imgSrcPath = URL.createObjectURL(blob)
            });
        },
        previewFile() {
            const rowData = {
                fileId: this.formData.delegateFileId,
                localFileName: this.formData.delegateFileName,
                downUrl: this.formData.delegateFileUrl,
            }
            this.rowData = rowData
            this.attachmentShow = true
        },
        /** 附件下载 **/
        handleDownloadTemplate(fileName, localFileName) {
            downloadAttachment(JSON.stringify({ fileName })).then(res => {
                let fileType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                const blob = new Blob([res], {
                    type: fileType
                });
                const objectUrl = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = objectUrl;
                a.download = localFileName;
                a.click();
            });
        },
        // 文件上传成功后回调
        handleUploadSuccess(result) {
            this.formData.delegateFileName = result.data.data.localFileName
            this.formData.delegateFileUrl = result.data.data.downUrl
            this.formData.delegateFileId = (new Date()).getTime()
        },
        detaliSearch(advanceCascade) {
            const supplierCode = this.checkedData[0].supplierCode
            this.$refs.advanceDialog.show(true, advanceCascade, { supplierCode })
        },
        // 选中高级组件值后回调
        detaliSearchSure(data) {
            Object.keys(data).forEach(k => {
                this.$set(this.formData, k, data[k]);
            });
        },
        // 重置高级组件
        resetAdvanceValue() {
            this.formData.stamperCode = ''
            this.formData.stamperName = ''
        },
        submit() {
            this.$refs.formRef.validate().then(async valid => {
                this.loading = true
                const isSupplier = !!this.$store.state.supplier
                const params = {
                    applyCodeList: this.checkedData.map(item => item.applyCode),
                    createSystemSource: isSupplier ? REGISTER_SOURCE.LSP : REGISTER_SOURCE.LSRM,
                    ...this.formData,
                }
                if (params.delegateOnline === DELEGATE_TYPE.OFFLINE) {
                    let checkRes = await checkWPH(params.delegateFileUrl).catch(err => {})
                    // 委派函检测不通过时跳出不往下执行
                    if (!checkRes || +checkRes.code !== 0) {
                        this.loading = false
                        return false
                    }
                }
                passApplyRecord(params).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('已同意司机加入!')
                        this.$emit('submit')
                        this.close()
                    }
                }).finally(() => { this.loading = false })
            })
        },
        handleSelect(value, prop) {
            this.formData[prop] = value;
        },
    }
}
</script>
<stype lang="less">
    .driver-add-supplier-driver-apply-dialog {
        .bold-title {
            font-weight: bold;
        }
        .el-form-item.delegate {
            padding-left: 15px;
            .el-form-item__label {
                width: 60px!important;
            }
            .el-form-item__content {
                margin-left: 75px!important;
            }
        }
        .el-form-item {
            .el-form-item__label, .el-form-item__content {
                line-height: 28px;
            }
        }
        .el-input__prefix {
            left: 91%;
        }
        .form-item-btn {
            color: #33c9cc;
            cursor: pointer;
            font-size: 12px;
            margin-left: 15px;
            text-decoration: underline;
        }
        .upload-item-icon {
            top: 6px !important;
        }
        .three-btn {
            width: 300px;
        }
        .delegate-wrapper {
            border: 1px solid #ccc;
            margin: 0 15px 5px 0;
            padding: 20px 0 0;
            .el-col-12, .el-col-24 {
                padding-left: 15px;
                padding-right: 15px;
            }
            .el-form-item.delegateFile {
                padding: 0 15px;
                // .el-form-item__label {
                //     width: 100px !important;
                // }
                // .el-form-item__content {
                //     margin-left: 100px!important;
                // }
            }
            .register-upload {
                position: absolute;
                .upload-demo {
                    height: 28px;
                }
                .el-upload {
                    width: 100%;
                    height: 100%;
                }
            }
            .el-form-item.stamperCode {
                width: 350px;
                .el-input {
                    .el-input__inner {
                        cursor: pointer;
                    }
                }
            }
            .el-form-item__content .el-input-group {
                vertical-align: middle;
            }
        }

        .push-type-form-item {
            .otp-select {
                width: 190.5px;
            }

            .push-type-tip {
                font-size: 12px;
                color: #d9001b;
            }
        }
    }
</stype>
